import React from 'react';
import './Home.css';
import heroImg from './dudigital.jpg';
import { useNavigate } from 'react-router-dom';
import { FaHockeyPuck, FaUsers, FaTrophy } from 'react-icons/fa';

const stats = [
  { value: '3', label: 'Elite Coaches' },
  { value: '100+', label: 'Athletes Trained' },
  { value: '#1', label: "Hamilton's Best" },
];

const services = [
  {
    icon: <FaHockeyPuck />,
    title: '1-on-1 Training',
    desc: 'Personalized coaching built around your goals. Refine your shot, sharpen your edgework, and build unshakeable confidence — every rep is about you.',
  },
  {
    icon: <FaUsers />,
    title: 'Group Sessions',
    desc: 'High-intensity group training in a competitive environment. Learn systems, read plays, build chemistry, and develop the core skills that separate elite players.',
  },
  {
    icon: <FaTrophy />,
    title: 'Elite Development',
    desc: 'Coached by players who have done it at the highest levels — OJHL, OHL, AHL, and NCAA. Real experience, real results, no shortcuts.',
  },
];

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="home">
      {/* Hero */}
      <section
        className="hero"
        style={{ backgroundImage: `url(${heroImg})` }}
      >
        <div className="hero__overlay" />
        <div className="hero__content">
          <p className="hero__eyebrow">Hamilton, Ontario</p>
          <h1 className="hero__title">Train Like a Pro.<br />Play Like a Pro.</h1>
          <p className="hero__sub">
            RFR Pro is Hamilton's premier hockey school — where serious athletes come to level up.
          </p>
          <div className="hero__actions">
            <button className="btn btn--primary" onClick={() => navigate('/contact')}>
              Book a Session
            </button>
            <button className="btn btn--ghost" onClick={() => navigate('/about')}>
              Meet the Coaches
            </button>
          </div>
        </div>
      </section>

      {/* Stats Strip */}
      <section className="stats">
        {stats.map(({ value, label }) => (
          <div className="stats__item" key={label}>
            <span className="stats__value">{value}</span>
            <span className="stats__label">{label}</span>
          </div>
        ))}
      </section>

      {/* Services */}
      <section className="services">
        <div className="section-header">
          <h2>What We Offer</h2>
          <p>Purpose-built programs for players who want to make the jump.</p>
        </div>
        <div className="services__grid">
          {services.map(({ icon, title, desc }) => (
            <div className="service-card" key={title}>
              <div className="service-card__icon">{icon}</div>
              <h3>{title}</h3>
              <p>{desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Banner */}
      <section className="cta-banner">
        <div className="cta-banner__inner">
          <h2>Ready to elevate your game?</h2>
          <p>See what players and parents are saying about RFR Pro.</p>
          <button className="btn btn--primary" onClick={() => navigate('/reviews')}>
            Read the Reviews
          </button>
        </div>
      </section>
    </div>
  );
};

export default Home;
